export default "__VITE_ASSET__58880760__"